// extracted by mini-css-extract-plugin
module.exports = {"mds-profile-image":"mds-profile-image___devsite"};